import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import MailImg from '../../assets/img/mail-img.png';
import PhoneImg from '../../assets/img/phone-img.png';

const ContactInfo = ({language}) => {
    return (
        <section className="contactPage-info">
            <Container>
                <Row className='align-items-center mb-5'>
                    <h2 className='text-center'>{language === "Chinese" ? "聯絡資訊" : "Contact Information"}</h2>
                    <Col md={6} className='my-5'>
                        <a href="tel:+886227271786,1913">
                            <h3>
                                <span><img src={PhoneImg} alt={language === "Chinese" ? "電話" : "Phone"} /></span>{language === "Chinese" ? "02-2727-1786 分機 1913" : "+886-2-2727-1786 ext. 1913"}
                            </h3>
                        </a>
                    </Col>
                    <Col md={6} className='my-5'>
                        <a href="mailto:letapesunmoonlake@gmail.com">
                            <h3>
                                <span><img src={MailImg} alt={language === "Chinese" ? "電子郵件" : "Email"} /></span>letapesunmoonlake@gmail.com
                            </h3>
                        </a>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ContactInfo